/**
 * @generated SignedSource<<12e2bbaaabb8d4e5c1f4e488c07b72d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuDrawer_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineMenuSelector_viewer">;
  readonly " $fragmentType": "SbRespRefineMenuDrawer_viewer";
};
export type SbRespRefineMenuDrawer_viewer$key = {
  readonly " $data"?: SbRespRefineMenuDrawer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineMenuDrawer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenuDrawer_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuSelector_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f164a782782dc050ee360e8eb89f2271";

export default node;
